import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "dottedBox",
  style: {"width":"81%","position":"absolute","bottom":"-5rem","right":"-61rem","height":"9rem"}
}
const _hoisted_2 = { class: "custom-file" }
const _hoisted_3 = { class: "text-center mt-n4" }
const _hoisted_4 = {
  type: "file",
  class: "custom-file-input",
  id: "exampleInputFile",
  accept: "image/png, image/jpeg, image/jpg",
  size: "3000000",
  "aria-describedby": "fileHelp",
  ref: "fileToUpload",
  multiple: "",
  style: {"height":"153px","position":"absolute","left":"-7%","width":"114%"}
}
const _hoisted_5 = { href: "#" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("input", _hoisted_4, null, 512),
          _cache[0] || (_cache[0] = _createElementVNode("span", {
            class: "k-icon k-i-image",
            size: "3x",
            style: {"margin-top":"57px"}
          }, null, -1)),
          _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("imageInputComp.dragYourImageHereOr")) + " ", 1),
            _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.browse), 1)
          ])
        ])
      ])
    ])
  ]))
}